/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getHealth} from '../api'

 export const useQueryGetHealth = createReactQueryHook('getHealth', getHealth)
